import { render, staticRenderFns } from "./Currencies.vue?vue&type=template&id=8d19d23a&scoped=true"
import script from "./Currencies.vue?vue&type=script&lang=js"
export * from "./Currencies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d19d23a",
  null
  
)

export default component.exports